$(function () {
    var headerTopAbs, headerTopPos, videoTopAbs, videoTopPos, viewHeight, loadHeight;
    var lifeCycleBlocksShown = 0;

    var systemSwiper = new Swiper('.billing_top .swiper-container', {
        slidesPerView: 1,
        loop: true,
        grabCursor: true,
        effect: 'fade',
        navigation: {
            nextEl: '.billing_top .swiper-button-next',
            prevEl: '.billing_top .swiper-button-prev',
        },
        autoplay: {
            delay: 2000,
            disableOnInteraction: false,
        },
    });

    $('.billing_top .swiper-container').hover(
        function() {
            systemSwiper.autoplay.stop()
        },
        function() {
            systemSwiper.autoplay.start()
        }
    );

    lifeCycleBlocks();


    $(window).on('windowResizeBreakpointChanged', function () {
        setLoadVars();
        loadBlock();
    });

    $(window).scroll(function() {
        lifeCycleBlocks();
        loadBlock();
    });

    function lifeCycleBlocks() {
        if (lifeCycleBlocksShown) {
            return;
        }

        var scrollTop = $(document).scrollTop();
        var windowHeight = $(window).height();
        var block1position = $('.life_cycle .item').eq(0).offset().top;
        var block2position = $('.life_cycle .item').eq(1).offset().top;
        var block3position = $('.life_cycle .item').eq(2).offset().top;
        var block4position = $('.life_cycle .item').eq(3).offset().top;
        var block5position = $('.life_cycle .item').eq(4).offset().top;
        //console.log(scrollTop, windowHeight, block1position);

        if ((scrollTop + windowHeight) > block1position) {
            $('.life_cycle .item').eq(0).find('.arrow').css('left', 0);
            $('.life_cycle .item').eq(0).removeClass('invis');
        }
        if ((scrollTop + windowHeight) > block2position) {
            $('.life_cycle .item').eq(1).find('.arrow').css('left', 0);
            $('.life_cycle .item').eq(1).removeClass('invis');
        }
        if ((scrollTop + windowHeight) > block3position) {
            $('.life_cycle .item').eq(2).find('.arrow').css('left', 0);
            $('.life_cycle .item').eq(2).removeClass('invis');
        }
        if ((scrollTop + windowHeight) > block4position) {
            $('.life_cycle .item').eq(3).find('.arrow').css('left', 0);
            $('.life_cycle .item').eq(3).removeClass('invis');
        }
        if ((scrollTop + windowHeight) > block5position) {
            $('.life_cycle .item').eq(4).find('.arrow').css('left', 0);
            $('.life_cycle .item').eq(4).removeClass('invis');
            lifeCycleBlocksShown = 1;
        }
    }

    function setLoadVars() {
        headerTopAbs = $('.billing-platform-page .life_cycle_block .container h3').offset().top;
        headerTopPos = $('.billing-platform-page .life_cycle_block .container h3').position().top + parseInt($('.billing-platform-page .life_cycle_block .container').css('marginTop'));
        loadHeight = parseInt($('.billing-platform-page .load').css('height'));
        //console.log('loadTop', headerTopPos);
        viewHeight = $(window).height();

        videoTopAbs = $('.billing-platform-page .life_cycle_block .video').offset().top;
        videoTopPos = $('.billing-platform-page .life_cycle_block .video').position().top + parseInt($('.billing-platform-page .life_cycle_block .container').css('marginTop')) - 100;
        //console.log('videoTopAbs', videoTopAbs, 'videoTopPos', videoTopPos);
    }

    function loadBlock() {
        if ($('.billing-platform-page .load').hasClass('stopped')) {
            $('.billing-platform-page .load').css('top', videoTopPos);
            return;
        }

        var scrollTop = $(document).scrollTop();

        //console.log('-----');
        //console.log('scrollTop =', scrollTop, 'viewHeight =', viewHeight, '+=', scrollTop+viewHeight);
        //console.log('headerTopAbs =', headerTopAbs);

        //if ((scrollTop + viewHeight) > (descrTopAbs + loadHeight + 100)) {
        if ((scrollTop + viewHeight) > (videoTopAbs + loadHeight)) {
            //console.log('stopped');
            $('.billing-platform-page .load').removeClass('fixed').addClass('stopped');
            //console.log('videoTopPos =', videoTopPos);
            $('.billing-platform-page .load').css('top', videoTopPos);

        } else if ((scrollTop + viewHeight) > (headerTopAbs + loadHeight + 100)) { // +
            //console.log('fixed');
            $('.billing-platform-page .load').removeClass('stopped').addClass('fixed');

        } else {
            //console.log('hidden');
            $('.billing-platform-page .load').removeClass('fixed');
            $('.billing-platform-page .load').css('top', headerTopPos);
        }
    }

    var fontLoaded = setTimeout(function() {
        setLoadVars();
        loadBlock();
        $('.billing-platform-page .load').css('opacity', '1');

        clearTimeout(fontLoaded);
    }, 3000);
});